import { render, staticRenderFns } from "./commentCard.vue?vue&type=template&id=00ca972a&scoped=true&"
import script from "./commentCard.vue?vue&type=script&lang=js&"
export * from "./commentCard.vue?vue&type=script&lang=js&"
import style0 from "./commentCard.vue?vue&type=style&index=0&id=00ca972a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ca972a",
  null
  
)

export default component.exports